import React from "react";
import PropTypes from 'prop-types';
import cx from "classnames";
import { BemHelper } from "utils/bemHelper";

import { useLazyChildRenderer } from "hooks/useLazyChildRenderer";

import { ReactComponent as Caret } from "assets/icons/caret.svg";

import "./Accordion.scss";

const noop = () => {};

const bem = new BemHelper("z-accordion");

export const Accordion = props => {
  const shouldRenderContent = useLazyChildRenderer(props.isOpen);

  const handleToggle = () => props.onToggle({isOpen: !props.isOpen})

  const classNames = cx([
    bem.component,
    {"is-open": props.isOpen},
  ]);

  return (
    <div className={classNames}>
        <label className={bem.for("trigger")} htmlFor={props.id}>
          <div className={bem.for("label")} dangerouslySetInnerHTML={{__html: props.label}}>
          </div>
          <div className={bem.for("icon")}>
            <Caret />
          </div>
        </label>
        <input type="checkbox" className={bem.for("toggle")}
          id={props.id}
          onChange={handleToggle}
        />
        {shouldRenderContent &&
          <div className={bem.for("content")}>
            {props.children}
          </div>
        }
    </div>
  );
};

Accordion.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func,
};

Accordion.defaultProps = {
  isOpen: false,
  onToggle: noop,
};